import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE_URL, getTenantId } from '../config/api';

const useCurrentPrestataire = () => {
  const { user, isAuthenticated } = useAuth();
  const [prestataire, setPrestataire] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCurrentPrestataire = useCallback(async () => {
    if (!isAuthenticated || !user?.id) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      const tenantId = getTenantId();

      const response = await fetch(`${API_BASE_URL}/prestataires`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'x-tenant-id': tenantId
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Trouver le prestataire correspondant à l'utilisateur actuel
      const currentPrestataire = data.find(p => p.user_id === user.id);
      
      if (currentPrestataire) {
        setPrestataire(currentPrestataire);
      } else {
        setError('Profil prestataire non trouvé pour cet utilisateur');
      }
    } catch (err) {
      console.error('Erreur lors de la récupération du prestataire actuel:', err);
      setError('Erreur lors de la récupération des données prestataire');
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, user?.id]);

  useEffect(() => {
    fetchCurrentPrestataire();
  }, [fetchCurrentPrestataire]);

  return { 
    prestataire, 
    prestataire_id: prestataire?.id || null,
    loading, 
    error,
    refetch: fetchCurrentPrestataire
  };
};

export default useCurrentPrestataire;